// Конфигурация сайта
const API_URL = process.env.REACT_APP_API_URL || 'https://air-room.shop';

export const config = {
  apiUrl: API_URL,
  telegram: {
    channel: 'https://t.me/+R5EpS-BAbIxmYzVi', // Замените на ваш Telegram канал
    manager: 'https://t.me/managerabcshop'   // Замените на вашего менеджера
  }
};

